import { PrimaryMetadata } from '../../types/rest/assetCatalogTypes';

export interface MarFile {
  id: number;
  name: string;
  description: null;
  type: string;
  folderId: string;
  fileId: string;
  primaryMetadata: PrimaryMetadata;
  secondaryMetadata: SvTransactions[];
  serviceMockMarDtos: ServiceMockMarDto[];
  created: number;
  updated: number;
  createdBy: string;
  updatedBy: string;
  serviceId: number;
  serviceName: string;
  tags: any[];
  createdDate: string;
  updatedDate: string;
}

export interface NodeList {
  name: string;
  type: string;
  dataProtocolList: DataProtocolList[] | null;
}

export interface DataProtocolList {
  name: string;
}

export interface SvTransactions {
  specificTxns: SvTransactions[] | null;
  request: Request;
  responses: Response[];
  node: boolean;
  allowDups: boolean;
  declineBeingCurrent: boolean;
  navigationTolerance: null;
  id: string;
}

export interface ServiceMockMarDto {
  id: number;
  name: string;
  harborId: string;
  shipId: string;
  status: string;
  httpEndpoint: string;
  httpsEndpoint: string;
  svEndpoint: string;
}

export interface Request {
  metaData: MetaDatum[];
  body: Body | null;
  arguments: MetaDatum[] | null;
  operationName: string;
  matchTolerance: 'EXACT' | 'SIGNATURE';
  disableMatchScript: boolean;
}

export interface MetaDatum {
  name: string;
  type: string | null;
  value: string;
  operator: string;
}

export enum OperatorType {
  EQUALS = '=',
  ANY = 'any',
  NOT_EQUALS = '!=',
  LESS_THAN = '<',
  LESS_THAN_OR_EQUALS = '<=',
  GREATER_THAN = '>',
  GREATER_THAN_OR_EQUALS = '>=',
  REGEX = 'regex',
  PROPERTY_EXPRESSION = 'property expression',
}

export interface Body {
  binary: boolean;
  charSet: string;
  body: string;
}

export interface Response {
  metaData: MetaDatum[] | null;
  body: Body | null;
  thinkTime: string;
}

export interface StatelessSignatures {
  operationName: string;
  id: number;
  devtestTxnId: number;
}

export interface Transactions {
  id: number;
  default: boolean;
}

export interface StatelessSignaturesTxsCount {
  transactions: Transactions[];
  transactionCount: number;
  operationName: string;
}
